var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quote"},[_c('span',{staticClass:"quote-text"},[_vm._v("\""+_vm._s(_vm.quoteText)+"\"")]),_c('span',{staticClass:"quote-author"},[_vm._v(_vm._s(_vm.quoteBy()))])])}
var staticRenderFns = []

export { render, staticRenderFns }